<template>
    <div>
    </div>
</template>
<script>
    // Components
    import {
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Empty,
        Notification,
        Form, 
        FormItem,
        Select,
        Option,
        Switch,
    } from "element-ui";

    // Schema
    import { validatePass, validateMatchPass } from "@/schemas/generalSchema"

    //Api
    import { UserApi } from "@/api/User/UserApi";

    const userApi = new UserApi();

    export default { 
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            deleteUser(id) {
                this.$confirm('Deseja realmente excluir este usuário?', 'Excluir usuário', {
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                }).then(async () => {
                    this.isLoading = true

                    // await this.onSubmit(id);
                }).finally(() => {
                    this.isLoading = false
                })
            },
            async onSubmit(id) {
                await userApi.delete(id)
                    .then(() => {
                        Notification.success({
                            title: 'Sucesso',
                            message: 'O usuário foi excluído com sucesso!'
                        });
                    }).catch((error) => {
                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível excluir o usuário!'
                        });
                    }).finally(() => {
                        this.isLoading = false;
                    });
            },
        },
        components: {
            [Dialog.name]: Dialog,
            [Notification.name]: Notification,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/User/UserDeleteModal.vue